export const ROUTES = {
  settings: {
    parentPath: "user",
    slug: "settings",
    route: "/user/settings",
  },
};
